<template>
    <div class="">
        <div class="py-4 rounded-lg">
            <div class="flex justify-between items-center px-6 py-2 mb-4 bg-a-orange-ffc8a1">
                <div class="text-16">ประกาศการเพิ่มชื่อผู้ขับขี่</div>
                <div class="bg-a-orange-fe5000 text-white rounded-full p-2 text-center text-14 w-20 h-8" @click="gotoLink()">คลิก</div>
            </div>
            <div v-if="document.policyListDataFullCustomerNotConfirm.length > 0">
                <div class="pb-4">
                    <div class="px-6 text-a-gray-555555 text-16">กรมธรรม์ที่รอตรวจสอบ</div>
                    <Notice>
                        เพื่อประโยชน์ของท่าน กรุณาตรวจสอบความคุ้มครองตามกรมธรรม์
                        กรณีข้อมูลไม่ถูกต้อง หรือ สอบถามเพิ่มเติม <a class="text-a-orange-f36e21 underline" href="tel:023089222">02-308-9222</a>
                    </Notice>
                    <div class="item-list"
                        v-for="(item, k) in document.policyListDataFullCustomerNotConfirm"
                        :item="item"
                        :key="k">
                        <ItemDocument :item="item" :isConfirm="item.policy.isConfirm"></ItemDocument>
                    </div>
                </div>
            </div>
            <div v-if="document.policyListDataFullCustomer.length > 0">
                <div class="px-6 pb-2 text-a-gray-555555 text-16">กรมธรรม์ของท่าน</div>
                <div class="item-list"
                    v-for="(item, k) in document.policyListDataFullCustomer"
                    :item="item"
                    :key="k">
                    <ItemDocument :item="item" :isConfirm="item.policy.isConfirm"></ItemDocument>
                </div>
            </div>
            <div v-if="document.policyListDataFullCustomerConfirmNull.length > 0">
                <div class="px-6 pb-2 text-a-gray-555555 text-16">กรมธรรม์ของท่าน</div>
                <div class="item-list"
                    v-for="(item, k) in document.policyListDataFullCustomerConfirmNull"
                    :item="item"
                    :key="k">
                    <ItemDocument :item="item" :isConfirm="item.policy.isConfirm"></ItemDocument>
                </div>
            </div>
           
            <div v-if="document.policyListDataTaxexp.length > 0">
                <Header>หนังสือรับรองลดหย่อนภาษีของท่าน</Header>
                <div class="item-list"
                    v-for="(item, k) in document.policyListDataTaxexp"
                    :item="item"
                    :key="k">
                    <ItemDocument :item="item" :type="'tax'"></ItemDocument>
                </div>
            </div>

            <div v-if="document.policyListDataEpacCard.length > 0" class="mt-3">
                <Header>E-Care Card</Header>
                <div class="item-list"
                    v-for="(item, k) in document.policyListDataEpacCard"
                    :item="item"
                    :key="k">
                    <ItemDocument :item="item" :type="'ecard'"></ItemDocument>
                </div>
                <!-- <Notice>
                    หากข้อมูลของท่านไม่ถูกต้อง กรุณาติดต่อศูนย์บริการลูกค้า <a class="link" href="tel:023089222">โทร. 02-308-9222</a><br/>
                    วันและเวลาทำการ จันทร์ - ศุกร์ เวลา 8.30 - 17.00 น.
                </Notice> -->
            </div>
            <div v-if="document.policyListRenew.length > 0">
                <Header>PA All Free Card</Header>
                <div class="px-6 text-a-gray-555555 text-16 pb-4">ใบเตือนต่ออายุ</div>
                <div class="item-list"
                    v-for="(item, k) in document.policyListRenew"
                    :item="item"
                    :key="k">
                    <ItemDocument :item="item" type="renew"></ItemDocument>
                </div>
            </div>
            <Notice>
                หมายเหตุ
                <ul class="list-disc list-inside">
                    <li>ระบบ iOS เอกสารจะถูกจัดเก็บที่ My File</li>    
                    <li>ระบบ Android เอกสารจะถูกจัดเก็บที่แอปพลิเคชัน Books/ Library</li>
                    <li>ท่านสามารถดาวน์โหลดหนังสือรองรับลดหย่อนภาษีได้เฉพาะประกันที่ได้รับสิทธิ์ลดหย่อนเท่านั้น</li>
                    <li>หากท่านพบปัญหาในการดาวน์โหลด หรือข้อมูลของท่านไม่ถูกต้อง กรุณาติดต่อศูนย์บริการลูกค้าโทร.<a class="text-a-orange-f36e21 underline" href="tel:023089222">02-308-9222</a> 
                    วันและเวลาทำการ จันทร์ – ศุกร์ เวลา 08.30 -17.00 น.</li>
                </ul>
                <!-- เพื่อประโยชน์ของท่าน กรุณาตรวจสอบความคุ้มครองตามกรมธรรม์
                กรณีข้อมูลไม่ถูกต้อง หรือ สอบถามเพิ่มเติม <a class="text-a-orange-f36e21 underline" href="tel:023089222">02-308-9222</a> 
                <br/>หมายเหตุ : กดเบอร์โทรออกได้ -->
            </Notice>
        </div>
    </div>
</template>

<script>

//component
import ItemDocument from './ItemDocument'
import Notice from './Notice'
import Header from './Header'

export default {
    name: 'Document',
    props: {
        document: Object,
    },
    components: {
        ItemDocument,
        Notice,
        Header,
    },
    data: function() {
        return {
            formData: null,
            isConfirm: null,
            isNotConfirm: null,
            isConfirmNull: null,
            supDocType: "",
        };
    },
    methods: {
        gotoLink() {
            window.open('https://inquiry.thanachartinsurance.co.th/articles/adddrivers/', '_blank');
        },
    },
}
</script>

<style lang="scss" scoped>
.link {
    @apply  text-a-orange-fe5000 underline font-medium;
}


</style>
